import { CaseProjection } from '../../CaseProjection';

export const getCaseSurfaceForSaleWarningLimit = (caseProjection: CaseProjection): number =>
  caseProjection.projectedMaxSurfaceForSale.value;
